import { academicGroupRouteMetadata } from "../academicGroup/route";

import {
  facultyAcademicGroupsRoutesObj,
  facultyAcademicGroupsBreadcrumbs,
} from "./path";

import { concatRoutesMetadata, createRoute } from "@/routes/utils";
import type { IPartialRouteMetadataObj } from "@/routes/types";

const partialFacultyAcademicGroupsRoutesMetadata: IPartialRouteMetadataObj<
  typeof facultyAcademicGroupsRoutesObj
> = {
  list: {
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroups/table/page"
      ),
  },
  create: {
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroups/form/page"
      ),
  },
  edit: {
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroups/form/page"
      ),
  },
  view: {
    lazy: () =>
      import(
        "@/pages/adminPanel/facultyManagement/facultyAcademicGroups/view/page"
      ),
  },
};

const facultyAcademicGroupsRoutesMetadata = concatRoutesMetadata<
  typeof facultyAcademicGroupsRoutesObj
>(academicGroupRouteMetadata, partialFacultyAcademicGroupsRoutesMetadata);

export const facultyAcademicGroupsRoutes = createRoute<
  typeof facultyAcademicGroupsRoutesObj
>(
  facultyAcademicGroupsRoutesObj,
  facultyAcademicGroupsRoutesMetadata,
  facultyAcademicGroupsBreadcrumbs,
);
